/***
 * 创建人：李珊
 * 时间：2020-07-14
 * 描述:查看标注列表
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from 'src/app//librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-mark-query',
  templateUrl: './mark-query.component.html',
  styleUrls: ['./mark-query.component.css']
})
export class MarkQueryComponent implements OnInit {
  //接收父组件的数据  
  @Input() bigImgUrl:string;              // 图片路径
  @Input() fileInfoId:string;             // 图片文件主键id
  @Input() createUsers:any = [];          // 当前选中的创建人id集合，用于标注列表查询
  @Input() showMarkList:boolean = false;  // 标注列表组件是否显示
  @Input() mode:string;                   // 状态：查看/编辑  
  // 点击编辑按钮时向父组件发射数据
  @Output('editMark') editMark = new EventEmitter<any>();  
  // 点击查看按钮时向父组件发射数据
  @Output('viewMark') viewMark = new EventEmitter<any>();
  // 复制标记成功后向父组件发射数据
  @Output('copyMark') copyMark = new EventEmitter<any>();  
  // 选中待删除的标注后向父组件发射数据
  @Output('deleteMarks') deleteMarks = new EventEmitter<any>();   
  // 标注列表表格组件
  @ViewChild("swtable") swtable: SwGridTableComponent;   
  // 标注列表表格按钮组配置
  toolbar = [
    {status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: []}
  ];
  //搜索关键字：标注名称
  markName = '';  
  //标注列表分页对象
  pageBase: any = {  
    current:1,
    size:6
  };
  //图片格式
  format;
  //标注列表数据
  datas = [];   
  //选中的标注  
  selectedData:any = [];  
  // 表格中行的按钮组
  tdBtns:any = [];
  constructor(
    private kmsService:KmsService,
    private box:SwMassageBoxService,
    private instanceModuleService: InstanceModuleService
  ) { }

  ngOnInit() {
    
  }
  
  ngOnChanges() {
    if(this.showMarkList){
      //获取图片格式
      this.format = this.instanceModuleService.getImgFormat(this.bigImgUrl);
      //初始化标注表格
      this.getData();  
    }
    if(this.mode=='edit' ||  this.mode == 'verify'){
      this.toolbar = [
        {status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-trash', children: []}
      ];
      this.tdBtns = [
        {
          id: 'edit',
          text: '编辑',
          icon: 'glyphicon glyphicon-pencil'
        },
        {
          id: 'view',
          text: '查看',
          icon: 'glyphicon glyphicon-eye-open'
        },
        {
          id: 'copy',
          text: '复制',
          icon: 'fa fa-clipboard'
        },
        {
          id: 'delete',
          text: '删除',
          icon: 'glyphicon glyphicon-remove'
        }
      ];
    }else{
      this.toolbar = [];
      this.tdBtns = [
        {
          id: 'view',
          text: '查看',
          icon: 'glyphicon glyphicon-eye-open'
        }
      ];
    }
  }

  //enter键触发搜索
  enterSearch(event){
      if(event.keyCode == '13'){
          this.clickSelect();
      }
  }

  //查询标注列表
  clickSelect(){
    this.markName = $.trim(this.markName);
    this.pageBase = {  
        current:1,
        size:6
    };
    this.getData();
  }

  //获取所有已关联标注列表
  getData(){
    const params = {
      'fileInfoId':this.fileInfoId,
      'markName':this.markName,
      'current':this.pageBase.current,
      'size':this.pageBase.size,
      'createUserList': this.createUsers
    }
    this.kmsService.queryImgMarks(params).subscribe(
      data => {
        if(data.code == '200'){
          this.pageBase = data.data;
          this.datas = data.data.records;
        }else{
          this.box.danger(data.msg);
        }
      }
    );
  }

  //点击标注列表数据回调
  OutSelectData(event) {
    // 获取当前选中的所有数据
    this.selectedData = event;   
    // 设置按钮组禁用
    this.swtable.toolbarAllEnable();
    if (this.selectedData.length == 0){
      this.swtable.toolbarDisable("delete");
    }
  }

  //标注列表分页触发事件
  clickPageQuery(event){
    this.pageBase.pageNum = event.current;
    this.pageBase.pageSize = event.size;
    this.getData();
  }

  //重置标注列表数据
  clickReloadData(){
    this.markName = '';
    this.pageBase = {  
        current:1,
        size:6
    };
    this.getData();
  }

  //标注按钮组点击事件
  onOperation(event){
    switch(event) {
      case "delete":this.clickDelete();break;//删除
    }
  }

  //删除标注
  clickDelete(){
    if (this.selectedData.length > 0) {
      this.deleteMarks.emit(this.selectedData);
    } else {
      this.box.danger('请至少选择一条数据！')
    }
  }

  /**
    * 点击td中的按钮
    * @ignore
    */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 复制
    if (type == 'copy') {
      this.kmsService.copyImageMark('primaryId='+data.imageMarkId).subscribe(
        res => {
          if(res.code == '200'){
            this.box.success('操作成功！');
            this.getData();
            this.copyMark.emit(res.data);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
    // 编辑
    else if (type == 'edit') {
      this.editMark.emit(data);
    }
    // 查看
    else if (type == 'view') {
      this.viewMark.emit(data);
    }
    // 删除
    else if (type == 'delete') {
      this.deleteMarks.emit([data]);
    }
  }
}
